import {FC} from 'react'
import {PageLink} from '../../../_metronic/layout/core'
import {RiskListHeader} from './components/header/RiskListHeader'
import {KTCard} from '../../../_metronic/helpers'
import {RiskManagement} from './table/RiskManagement'
import {RiskPageTitle} from '../../../_metronic/layout/core/RiskPageData'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const RiskManagementWrapper: FC = () => {

  return (
    <>
      <RiskPageTitle
        icon='personnelIcon.svg'
        title='Risk Management'
        desc={'Identify, assess, and mitigate risks to ensure compliance'}
        breadcrumbs={usersBreadcrumbs}
      >
        Risk Management
      </RiskPageTitle>

      <KTCard>
        <RiskListHeader />
        <RiskManagement />
      </KTCard>
    </>
  )
}

export default RiskManagementWrapper
